// client/src/components/marketer/result/modals/ApproveModal.js
import React, { useState } from 'react';
import '../../../../styles/marketer/modals/ResultApproveModals.css';

export default function ApproveModal({ open, onClose, influencerName, onConfirm }) {
  const [satisfactionScore, setSatisfactionScore] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);

  if (!open) return null;

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm(satisfactionScore);
    } finally {
      setIsConfirming(false);
    }
  };

  const scores = [
    { value: 5, emoji: '😍', label: '매우 만족' },
    { value: 4, emoji: '😊', label: '만족' },
    { value: 3, emoji: '😐', label: '보통' },
    { value: 2, emoji: '😕', label: '불만족' },
    { value: 1, emoji: '😞', label: '매우 불만족' }
  ];

  return (
    <div className="result-approve-modal mbm-overlay">
      <div className="result-approve-modal__content mbm" onClick={(e) => e.stopPropagation()}>
        {/* 닫기 버튼 */}
        <button onClick={onClose} className="result-approve-modal__close mbm-close">×</button>
        
        {/* 헤더 */}
        <div className="result-approve-modal__icon-container">
          <div className="result-approve-modal__icon">✓</div>
        </div>
        <h2 className="result-approve-modal__title mbm-title">결과물 승인</h2>
        <div className="result-approve-modal__subtitle">
          <strong>{influencerName}</strong>님의 결과물을 승인하시겠습니까?
        </div>

        {/* 만족도 평가 (선택사항) */}
        <div className="result-approve-modal__section">
          <div className="result-approve-modal__section-title">
            만족도 평가 <span className="result-approve-modal__optional">(선택사항)</span>
          </div>
          <div className="result-approve-modal__description">
            인플루언서의 성과를 평가해주세요. 이 평가는 향후 인플루언서 선정 시 참고자료로 활용됩니다.
          </div>
          
          <div className="result-approve-modal__score-container">
            {scores.map((score) => (
              <div
                key={score.value}
                onClick={() => setSatisfactionScore(score.value)}
                className={`result-approve-modal__score-item ${
                  satisfactionScore === score.value ? 'result-approve-modal__score-item--selected' : ''
                }`}
              >
                <div className="result-approve-modal__emoji">{score.emoji}</div>
                <div className="result-approve-modal__score-value">{score.value}점</div>
                <div className="result-approve-modal__score-label">{score.label}</div>
              </div>
            ))}
          </div>

          {satisfactionScore && (
            <div className="result-approve-modal__selected-message">
              <strong>{satisfactionScore}점</strong>을 선택하셨습니다.
            </div>
          )}
        </div>

        {/* 안내 메시지 */}
        <div className="result-approve-modal__info-box">
          <div className="result-approve-modal__info-title">⚠️ 승인 시 처리되는 내용</div>
          <ul className="result-approve-modal__info-list">
            <li>결과물이 <strong>승인 상태</strong>로 변경됩니다.</li>
            <li>인플루언서에게 <strong>보상 포인트가 자동 지급</strong>됩니다.</li>
            <li>만족도 평가를 선택하신 경우, 인플루언서의 <strong>평균 만족도 점수에 반영</strong>됩니다.</li>
            <li>승인 후에는 <strong>취소할 수 없습니다</strong>.</li>
          </ul>
        </div>

        {/* 버튼 */}
        <div className="result-approve-modal__button-group mbm-foot">
          <button
            onClick={onClose}
            disabled={isConfirming}
            className={`result-approve-modal__button result-approve-modal__button--cancel mb-btn mb-btn-secondary ${
              isConfirming ? 'result-approve-modal__button--disabled' : ''
            }`}
          >
            취소
          </button>
          <button
            onClick={handleConfirm}
            disabled={isConfirming}
            className={`result-approve-modal__button result-approve-modal__button--confirm mb-btn mb-btn-primary ${
              isConfirming ? 'result-approve-modal__button--disabled' : ''
            }`}
          >
            {isConfirming ? '처리 중...' : '승인하기'}
          </button>
        </div>
      </div>
    </div>
  );
}
